import { name as statusManagerName } from '../manager/statusManager'
import { name as statusEmailsName } from '../campaign/statusEmails'
import { name as statusCampaignName } from '../campaign/statusCampaign'
import { name as statusReportsName } from '../reports/statusReports'
import project from '../../../project.config'
import { createPayload } from '../utils/common'

export default function signalRStart (store, callback) {
  const _hub = $.connection.status

  $.extend(_hub.client, {
    message: function (name, data) {
      let parsedData = null
      console.log('SIGNAL R: ', name, data)
      try {
        parsedData = JSON.parse(data)
      } catch (e) {
        parsedData = {
          status: data
        }
      }
      const payload = createPayload(parsedData)
      switch (name) {
        case 'Changes':
          store.dispatch({ type: `${statusManagerName}_SET`, payload })
          break
        case 'Campaigns':
          store.dispatch({ type: `${statusCampaignName}_SET`, payload })
          break
        case 'Emails':
          store.dispatch({ type: `${statusEmailsName}_SET`, payload })
          break
        case 'Reports':
          store.dispatch({ type: `${statusReportsName}_SET`, payload })
          break
      }
    }
  })
  $.connection.hub.url = project.signalRHubUrl
  $.connection.hub.start({}, () => callback())
}



// WEBPACK FOOTER //
// ./src/store/signalR/signalRStart.js